import { ReportRepository } from "@domain/repositories/ReportRepository";
import UseCase from "@domain/UseCase";
import { Report } from "@domain/models/Report";

type Input = Report["id"];

type Output = Promise<Report[]>;

export class DeleteReportUseCase implements UseCase<Input, Output> {
  constructor(private readonly reportRepository: ReportRepository) {
    this.reportRepository = reportRepository;
  }

  async execute(reportId: Input) {
    return this.reportRepository.delete(reportId);
  }
}
